const AppSettingsPage = () => {
  return <div className="p-3">App Settings UI</div>;
};
export default AppSettingsPage;